import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'reactstrap/lib';
import { CarouselTagList } from 'site-modules/shared/components/carousel-tag-list/carousel-tag-list';

import './carousel-tags-description.scss';

export class CarouselTagsDescription extends Component {
  state = {
    isMobile: this.props.isMobile,
    barIsOpen: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (state.isMobile !== props.isMobile) {
      return {
        isMobile: props.isMobile, // remember initial value
        barIsOpen: !props.isMobile,
      };
    }
    return null;
  }

  toggleBar = () => {
    this.setState(prevState => ({
      barIsOpen: !prevState.barIsOpen,
    }));
  };

  render() {
    const { tagList, setTag, currentTag, description } = this.props;
    const { barIsOpen } = this.state;
    if (!((tagList && tagList.length) || description)) return null;
    return (
      <div>
        <div className={classNames('carousel-tag-description-bar', { open: barIsOpen })}>
          <div className="pt-1 text-end">
            <div className="carousel-tag-description-bar-content">
              <CarouselTagList
                tagList={tagList}
                onTagSelect={setTag}
                currentTag={currentTag}
                onClose={this.toggleBar}
              />
              <div className="carousel-description hidden-md-down h6">{barIsOpen && description}</div>
            </div>
          </div>
          <Button
            className={classNames('carousel-description-toggle hidden-md-down', {
              'icon-minus3': barIsOpen,
              'icon-plus3': !barIsOpen,
            })}
            onClick={this.toggleBar}
            aria-label={barIsOpen ? 'Hide details' : 'Show details'}
          />
        </div>
        <Button
          className={classNames('carousel-description-toggle hidden-md-up', {
            'icon-minus3': barIsOpen,
            'icon-plus3': !barIsOpen,
          })}
          onClick={this.toggleBar}
          aria-label={barIsOpen ? 'Hide details' : 'Show details'}
        />
      </div>
    );
  }
}

CarouselTagsDescription.propTypes = {
  tagList: PropTypes.arrayOf(PropTypes.string),
  setTag: PropTypes.func,
  currentTag: PropTypes.string,
  description: PropTypes.string,
  isMobile: PropTypes.bool,
};

CarouselTagsDescription.defaultProps = {
  tagList: null,
  setTag: null,
  currentTag: null,
  description: '',
  isMobile: false,
};
